<template>
  <div class="d-flex steps">
    <div
      class="progress"
      v-for="(item, i) in $t('buyers.add.progressSteps')"
      :key="i"
      :class="[isActive(i + 1).active, i]"
    >
      <div
        role="progressbar"
        class="progress-bar"
        :style="{ width: isActive(i + 1).completed + '%' }"
      >
        <div class="status d-flex d-md-flex flex-column flex-md-row">
          <h3>{{ item.step }}</h3>
          <h4>{{ item.text }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/variables';
.steps {
  margin: 3rem 0;
  .progress {
    height: 0.2rem;
    flex: 1;
    margin: 2rem 0;
    .progress-bar {
      &:before {
        content: '';
        width: 40px;
        height: 40px;
        border-radius: 50px;
        position: absolute;
      }
      &:after {
        content: '';
        width: 20px;
        height: 20px;
        border-radius: 50px;
        position: absolute;
        text-align: center;
        margin-left: 10px;
      }
      .status {
        position: absolute;
        display: flex;
        color: $gray-600;
        top: 0;
        align-items: center;

        h3 {
          font-size: 3rem;
          margin: 0;
          padding-right: 1rem;
        }
        h4 {
          font-size: 1.25rem;
          margin: 0;
          text-align: left;
        }
      }
    }
    &.disabled {
      .progress-bar {
        &:before {
          background: #dee2e6;
          box-shadow: 0 0 0 #dee2e6;
        }
        &:after {
          background: #fff;
          box-shadow: 0 0 0 1px;
        }
      }
    }
    &.active {
      .progress-bar {
        &:before {
          box-shadow: 0 0 10px #72c2a2;
          border: 3px solid #25b67c;
          background: #f0f0f0;
        }
        &:after {
          background: #25b67c;
          box-shadow: 0 0 39px 1px;
        }
      }
    }
    &.completed {
      .progress-bar {
        &:before {
          background: #72c2a2;
          box-shadow: 0 0 10px #72c2a2;
        }
        &:after {
          background: #25b67c;
          box-shadow: 0 0 39px 1px;
        }
      }
    }
    &:last-child {
      flex: 0;
    }
  }
}
@include media-breakpoint-down(sm) {
  .steps {
    transform: scale(0.9);
    position: relative;
    left: -1.25rem;
    .progress {
      .status {
        width: 100%;
        top: -5rem !important;
        left: 2rem;
      }
    }

    .progress:first-child {
      .status {
        align-items: flex-start;
        left: 0;
      }
    }
    .progress:last-child {
      .status {
        align-items: flex-end;
        right: 0;
        width: 110%;
      }
    }
  }
}
</style>

<script>
export default {
  methods: {
    isActive(i) {
      if (this.step === i) {
        return {
          active: 'active',
          completed: 0
        }
      } else if (this.step < i) {
        return {
          active: 'disabled',
          completed: 0
        }
      } else {
        return {
          active: 'completed',
          completed: 100
        }
      }
    }
  },
  props: ['step']
}
</script>
